import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import BrandWriteDTO from '../../../../../../types/brand/BrandWriteDTO';
import Media from '../../../../../../types/media/Media';
import { BrandService } from '../../../../services/brand.service';
import {
    SelectOrUploadMediaComponent
} from '../../media/select-or-upload-media-dialog/select-or-upload-media.component';

@Component({
    selector: 'app-create-brand-dialog',
    templateUrl: './create-brand-dialog.component.html',
    styleUrls: [ './create-brand-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        SelectOrUploadMediaComponent,
    ]
})
export class CreateBrandDialogComponent {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() brandCreated: EventEmitter<BrandWriteDTO> = new EventEmitter<BrandWriteDTO>();

    constructor(private brandService: BrandService,
                private messageService: MessageService) {
    }

    public brand: BrandWriteDTO = new BrandWriteDTO({});
    public media: Media | undefined = undefined;

    public loading = false;

    get saveDisabled(): boolean {
        return !this.brand.name || !this.brand.label;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public saveBrand() {
        this.loading = true;
        if (this.media) {
            this.brand.imageId = this.media.id;
        }
        this.brandService.createBrand(this.brand).then(() => {
            this.brandCreated.emit(this.brand);
            this.close();
        }).catch((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }).finally(() => {
            this.brand = new BrandWriteDTO({});
            this.loading = false;
        });
    }

}
